import Hero from './Hero';
import Feature from './Feature';
import Header from './Header';
import Maintenance from './Maintenance';

export const PuckConfig = {
	components: {
		Hero: {
			label: 'Hero',
			fields: {
				backgroundColor: {
					type: 'text'
				},
				primaryColor: {
					type: 'text'
				},
				secondaryColor: {
					type: 'text'
				},
				tertiaryColor: {
					type: 'text'
				},
				quaternaryColor: {
					type: 'text'
				},
				title: {
					type: 'text'
				},
				subTitle: {
					type: 'text'
				},
				imageUrl: {
					type: 'text'
				},
				btntxt: {
					type: 'text'
				},
				btnUrl: {
					type: 'text'
				},
				btntxt2: {
					type: 'text'
				},
				btnUrl2: {
					type: 'text'
				}
			},
			defaultProps: {
				backgroundColor: '#ffffff',
				primaryColor: '#2563eb',
				secondaryColor: '#ffffff',
				tertiaryColor: '#000000 ',
				quaternaryColor: '#9e9e9e',
				title: 'Payments tool for software companies',
				subTitle:
					'From checkout to global sales tax compliance, companies around the world use Flowbite to simplify their payment stack.',
				imageUrl: 'https://flowbite.s3.amazonaws.com/blocks/marketing-ui/hero/phone-mockup.png',
				btntxt: 'Get started',
				btnUrl: '',
				btntxt2: 'Speak to Sales',
				btnUrl2: ''
			},
			render: ({
				primaryColor,
				secondaryColor,
				tertiaryColor,
				quaternaryColor,
				title,
				subTitle,
				imageUrl,
				backgroundColor,
				btntxt,
				btnUrl,
				btntxt2,
				btnUrl2
			}) => {
				return (
					<Hero
						title={title}
						subTitle={subTitle}
						imageUrl={imageUrl}
						backgroundColor={backgroundColor}
						primaryColor={primaryColor}
						secondaryColor={secondaryColor}
						tertiaryColor={tertiaryColor}
						quaternaryColor={quaternaryColor}
						btntxt={btntxt}
						btnUrl={btnUrl}
						btntxt2={btntxt2}
						btnUrl2={btnUrl2}
					></Hero>
				);
			}
		},
		Feature: {
			label: 'Feature',
			fields: {
				backgroundColor: {
					type: 'text'
				},
				primaryColor: {
					type: 'text'
				},
				secondaryColor: {
					type: 'text'
				},
				tertiaryColor: {
					type: 'text'
				},
				title: {
					type: 'text'
				},
				subTitle: {
					type: 'text'
				},
				footerTitle: {
					type: 'text'
				},
				features: {
					type: 'array',
					arrayFields: {
						label: { type: 'text' }
					},
					defaultItemProps: {
						label: 'Continuous integration and deployment'
					}
				},
				imageUrl: {
					type: 'text'
				},
				title2: {
					type: 'text'
				},
				subTitle2: {
					type: 'text'
				},
				features2: {
					type: 'array',
					arrayFields: {
						label: { type: 'text' }
					},
					defaultItemProps: {
						label: 'Dynamic reports and dashboards'
					}
				},
				footerTitle2: {
					type: 'text'
				},
				imageUrl2: {
					type: 'text'
				}
			},
			defaultProps: {
				backgroundColor: '#ffffff',
				primaryColor: '#2563eb',
				secondaryColor: '#212121',
				tertiaryColor: '#9e9e9e',
				title: 'Work with tools you already use',
				subTitle:
					'Deliver great service experiences fast - without the complexity of traditional ITSM solutions.Accelerate critical development work, eliminate toil, and deploy changes with ease.',
				features: [
					{
						label: 'Continuous integration and deployment'
					}
				],
				footerTitle:
					'Deliver great service experiences fast - without the complexity of traditional ITSM solutions.',
				imageUrl: 'https://flowbite.s3.amazonaws.com/blocks/marketing-ui/features/feature-office-1.png',
				title2: 'We invest in the world’s potential',
				subTitle2:
					'Deliver great service experiences fast - without the complexity of traditional ITSM solutions.Accelerate critical development work, eliminate toil, and deploy changes with ease.',
				features2: [
					{
						label: 'Dynamic reports and dashboards'
					}
				],
				footerTitle2:
					'Deliver great service experiences fast - without the complexity of traditional ITSM solutions.',
				imageUrl2: 'https://flowbite.s3.amazonaws.com/blocks/marketing-ui/features/feature-office-2.png'
			},
			render: ({
				title,
				subTitle,
				features,
				footerTitle,
				imageUrl,
				title2,
				subTitle2,
				features2,
				footerTitle2,
				imageUrl2,
				backgroundColor,
				primaryColor,
				secondaryColor,
				tertiaryColor
			}) => {
				return (
					<Feature
						title={title}
						subTitle={subTitle}
						features={features}
						footerTitle={footerTitle}
						imageUrl={imageUrl}
						title2={title2}
						subTitle2={subTitle2}
						features2={features2}
						footerTitle2={footerTitle2}
						imageUrl2={imageUrl2}
						backgroundColor={backgroundColor}
						primaryColor={primaryColor}
						secondaryColor={secondaryColor}
						tertiaryColor={tertiaryColor}
					></Feature>
				);
			}
		},
		Header: {
			label: 'Header',
			fields: {
				backgroundColor: {
					type: 'text'
				},
				primaryColor: {
					type: 'text'
				},
				secondaryColor: {
					type: 'text'
				},
				tertiaryColor: {
					type: 'text'
				},
				title: {
					type: 'text'
				},
				title2: {
					type: 'text'
				},
				subTitle: {
					type: 'text'
				},
				footerSubTitle: {
					type: 'text'
				},
				footerSubTitle2: {
					type: 'text'
				},
				btntxt: {
					type: 'text'
				},
				btnUrl: {
					type: 'text'
				},
				btntxt2: {
					type: 'text'
				},
				btnUrl2: {
					type: 'text'
				},
				imageUrl: {
					type: 'text'
				}
			},
			defaultProps: {
				backgroundColor: '#ffffff',
				primaryColor: '#e53935',
				secondaryColor: '#212121',
				tertiaryColor: '#616161',
				title: 'VIRTUALLY. [ ANYONE ]. CAN',
				title2: '[My]Cylution',
				subTitle:
					'provides unmatched cyber protection, empowering everyone to live securely in a digital world.',
				footerSubTitle:
					'Are you 100% sure your secure secure while online? Are your loved ones safe when surfing the net? Is your digital presence protected from cyber threats?',
				footerSubTitle2:
					'If not, [My]Cylution is your solution to live securely in a digital world. [My]Cylution provides unmatched cyber protection, empowering everyone.',
				btntxt: 'Secure every click',
				btnUrl: '',
				btntxt2: 'Download our Playbook',
				btnUrl2: '',
				imageUrl:
					'https://briiskiuat.blob.core.windows.net/organisation-channel-images/9527f178-e2d3-46dc-9b18-d159913131c4'
			},
			render: ({
				title,
				title2,
				subTitle,
				footerSubTitle,
				footerSubTitle2,
				btntxt,
				btntxt2,
				btnUrl,
				btnUrl2,
				imageUrl,
				backgroundColor,
				primaryColor,
				secondaryColor,
				tertiaryColor
			}) => {
				return (
					<Header
						title={title}
						title2={title2}
						subTitle={subTitle}
						footerSubTitle={footerSubTitle}
						footerSubTitle2={footerSubTitle2}
						btntxt={btntxt}
						btnUrl={btnUrl}
						btntxt2={btntxt2}
						btnUrl2={btnUrl2}
						imageUrl={imageUrl}
						backgroundColor={backgroundColor}
						primaryColor={primaryColor}
						secondaryColor={secondaryColor}
						tertiaryColor={tertiaryColor}
					></Header>
				);
			}
		},
		Maintenance: {
			label: 'Maintenance',
			fields: {
				title: {
					type: 'text'
				},
				sub_title: {
					type: 'text'
				},
				image_url: {
					type: 'text'
				}
			},
			defaultProps: {
				title: 'Down for Maintenance',
				sub_title:
					'Down for planned maintenance. Well be back with the latest components and sections this week. Follow us on Twitter or our for blog latest updates.',
				image_url:
					'https://briiskidev.blob.core.windows.net/organisation-channel-images/81bf026a-0184-4e06-a372-2069cfaa76ec'
			},
			render: ({ title, sub_title, image_url }) => {
				return <Maintenance title={title} sub_title={sub_title} image_url={image_url}></Maintenance>;
			}
		}
	},
	root: {
		render: ({ children }) => {
			return (
				<div className="bg-white flex flex-col flex-1 flex-shrink-0 w-full mx-auto h-auto min-h-screen py-4 px-2">
					{children}
				</div>
			);
		}
	}
};
